import { useGetRoom, type RoomDetailInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Spinner } from "@chakra-ui/react";
import { RoomDescription } from "./components";
import { CustomDivider, CustomTitle } from "./roomDetail.style";

export const RoomDetail = ({ roomIdx }: { roomIdx: string }) => {
    const { data } = useGetRoom<RoomDetailInfoResponse>({ section: "detail", roomIdx });
    const { isMobile, isTablet } = MEDIA();

    return data ? (
        <Box position="relative">
            <Box as="section" p={isTablet ? "64px 0 0" : "128px 0 0 "}>
                <Center w="100%" justifyContent="space-between">
                    <CustomDivider w={isTablet ? "200px" : "360px"} />
                    <CustomTitle>{data.roomDetailInfo.name}</CustomTitle>
                    <CustomDivider w={isTablet ? "200px" : "360px"} />
                </Center>
                <Box
                    position="absolute"
                    left="0"
                    mt={isMobile ? "32px" : "60px"}
                    w="100%"
                    h="480px"
                    background={`url(${data.roomDetailInfo.imgGroup.main}) no-repeat center/cover`}
                ></Box>
                <RoomDescription roomDetailInfo={data.roomDetailInfo} />
            </Box>
        </Box>
    ) : (
        <Spinner />
    );
};
